import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { MyRankingData, Ranking } from "../../my-ranking/my-ranking.model";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { RankingInfo } from "../cxone-my-ranking.model";

@Component({
    selector: "cxone-my-ranking-card",
    templateUrl: "./my-ranking-card.component.html",
    styleUrls: ["./my-ranking-card.component.scss"],
})
export class MyRankingCardComponent {
    @Input() myRank: MyRankingData;
    @ViewChild('metricNameElement') metricNameElement: ElementRef;

    constructor(private localizationService: CVLocalizationService) {}
    getSourceIcon(trend: Ranking): string {
        switch (trend) {
            case Ranking.High:
                return "../App_Themes/CXone/icons/high-trend.svg#high-trend";
            case Ranking.Medium:
                return "../App_Themes/CXone/icons/mid-trend.svg#mid-trend";
            case Ranking.Low:
                return "../App_Themes/CXone/icons/low-trend.svg#low-trend";
            default:
                return "";
        }
    }

    getLocalization(key: string, defaultValue: string): string {
        return this.localizationService.getCachedText("My_Ranking", key, defaultValue);
    }

    getLabel(trend: Ranking): string {
        switch (trend) {
            case Ranking.High:
                return this.getLocalization(
                    "High",
                    "High"
                );
            case Ranking.Medium:
                return this.getLocalization(
                    "Medium",
                    "Mid"
                );
            case Ranking.Low:
                return this.getLocalization(
                    "Low",
                    "Low"
                );
            default:
                return this.getLocalization(
                    "NA",
                    "N/A"
                );
        }
    }

    getClass(trend: Ranking): string {
        const baseClass = "my-ranking-card__position-icon-label";
        switch (trend) {
            case Ranking.High:
                return `${baseClass} high`;
            case Ranking.Medium:
                return `${baseClass} medium`;
            case Ranking.Low:
                return `${baseClass} low`;
            default:
                return "my-ranking-card__no-rank";
        }
    }

    getInfo(type: RankingInfo): string {
        if (this.myRank.ranking === 3) {
            return type === 'position' ? '1/1' : '--';
        }

        if (type === "percentile" && this.myRank.totalGroups === 1) {
            return '--';
        }

        switch (type) {
            case "value":
                return this.myRank.metricDisplayValue;
            case "position":
                return `${this.myRank.rank}/${this.myRank.totalGroups}`;
            case "percentile":
                return this.getFormattedPercentile();
            case "icon":
                return this.getLabel(this.myRank.ranking);
            default:
                return "--";
        }
    }

    calculatePercentile(): number {
        if (
            !this.myRank ||
            !this.myRank.totalGroups ||
            this.myRank.rank > this.myRank.totalGroups
        ) {
            return 0;
        }

        const exactPercentile =
            ((this.myRank.totalGroups - this.myRank.rank) /
                this.myRank.totalGroups) *
            100;

        return Math.ceil(exactPercentile / 10) * 10;
    }

    getFormattedPercentile(): string {
        const percentile = this.calculatePercentile();

        if (percentile === 0) {
            return `0${this.getLocalization("Th_Symbol", "th")}`;
        }

        if (percentile === 11 || percentile === 12 || percentile === 13) {
            return `${percentile}${this.getLocalization("Th_Symbol", "th")}`;
        }

        const lastDigit = percentile % 10;
        switch (lastDigit) {
            case 1:
                return `${percentile}${this.getLocalization("St_Symbol", "st")}`;
            case 2:
                return `${percentile}${this.getLocalization("Nd_Symbol", "nd")}`;
            case 3:
                return `${percentile}${this.getLocalization("Rd_Symbol", "rd")}`;
            default:
                return `${percentile}${this.getLocalization("Th_Symbol", "th")}`;
        }
    }

    isTextTruncated(): boolean {
        if (!this.metricNameElement || !this.metricNameElement.nativeElement) {
            return false;
        }
        const element = this.metricNameElement.nativeElement;
        return element.scrollWidth > element.clientWidth;
    }
}

